import router from './router';
import store from './store';
import {
  hasLogined,
  isTwicePwded,
  isInGame,
  parseUserInfoFromCookie,
} from './utils';
import {
  repeatCertify,
  getMyMaps,
  getMyActs,
  getActWhiteState,
} from '@/api/common';
// 进度条
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
NProgress.configure({ showSpinner: false });
/*function isTwicePwded() {
  const token = sessionStorage.getItem('token2')
  //console.log('****'+token)
  if(token)  return true
  return false
}   */
// 开关
let hasAddedRoutes = false;
let getMapsIng = false;
let getActsIng = false;
let hasInited = false;
router.beforeEach(async (to, from, next) => {
  NProgress.start();
  const isToLogin = to.path === '/login';
  const isToCertify = to.name === 'Certify';
  if (hasLogined()) {
    //debugger
    let userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}');
    window.MiniService.UserService.init(isInGame ? 1 : 2, userInfo);
    let data = { uin: userInfo.uin };
    if (!hasInited) {
      try {
        hasInited = true;
        if (!getMapsIng) {
          getMapsIng = true;
          getMyMaps({
            json: 1,
          }).then(res => {
            const { code, data } = res;
            if (code === 0 && data.map_info_list) {
              const keys = Object.keys(data.map_info_list);
              const mapList = [];
              for (let i = 0; i < keys.length; i++) {
                mapList.push({
                  label: data.map_info_list[keys[i]]['name'],
                  value: keys[i],
                });
              }
              if (mapList.length) {
                localStorage.setItem(
                  'my_maps_' + userInfo.uin,
                  JSON.stringify(mapList),
                );
              }
            }
            setTimeout(() => {
              getMapsIng = false;
            }, 1200);
          });
        }
        if (!getActsIng) {
          getActsIng = true;
          getMyActs({ json: 1, page: 1, page_size: 30 }).then(res => {
            const { code, data } = res;
            if (code === 0 && data.list.length) {
              localStorage.setItem(
                'my_acts_' + userInfo.uin,
                JSON.stringify(data.list),
              );
            }
            setTimeout(() => {
              getActsIng = false;
            }, 1200);
          });
        }
        const whiteRes = await getActWhiteState();
        console.log('whiteRes----', whiteRes);
        if (whiteRes.code === 0) {
          const authority = whiteRes.data[0].authority;
          if (
            Object.prototype.toString.call(authority).slice(8, -1) === 'Number'
          ) {
            localStorage.setItem('act_canusee' + userInfo.uin, 1);
          } else {
            localStorage.setItem('act_canusee' + userInfo.uin, 0);
          }
        }
      } catch (err) {
        hasInited = false;
        console.error(err);
      }
    }
    // const userInfo1=sessionStorage.getItem('userInfo')
    //  console.log('***---'+userInfo1)
    //console.log('***'+sessionStorage.getItem('userInfo1'))
    // 如果已登录的情况，访问登录页，直接跳到首页
    //  debugger;
    if (isToLogin) {
      if (isTwicePwded()) {
        next({ path: '/' });
      } else {
        if (isToCertify) {
          next({ path: '/' });
        } else {
          let res = await repeatCertify(data);
          console.log('---' + res.code);
          if (res.code === 500) {
            next({ name: 'Certify', params: { uin: userInfo.uin } });
          } else {
            next({ path: '/' });
          }
        }
        //  isToCertify ? next() : next({ name: 'Certify', params: { uin: userInfo.uin }})
      }
    } else {
      if (!hasAddedRoutes) {
        hasAddedRoutes = true;
        await store.dispatch('addAsyncRoutes');
        if (isTwicePwded()) {
          next({ ...to });
        } else {
          //    isToCertify ? next({...to}) : next({ name: 'Certify', params: { uin: userInfo.uin }})
          if (isToCertify) {
            next({ ...to });
          } else {
            let res = await repeatCertify(data);
            //   console.log('***'+res.code)
            if (res.code === 500) {
              next({ name: 'Certify', params: { uin: userInfo.uin } });
            } else {
              //  debugger
              next({ ...to });
            }
          }
        }
        // router.push({ ...to }); // 修复控制台报 ”Redirected when going from "/login" to "/home" via a navigation guard.“ 问题
      } else {
        if (isTwicePwded()) {
          next();
        } else {
          //  isToCertify ? next() : next({ name: 'Certify', params: { uin: userInfo.uin }})
          if (isToCertify) {
            next();
          } else {
            let res = await repeatCertify(data);
            //  console.log('+++'+res.code)
            if (res.code === 500) {
              next({ name: 'Certify', params: { uin: userInfo.uin } });
            } else {
              next();
            }
          }
        }
      }
    }
    NProgress.done();
  } else {
    // 未登录的情况，允许访问登录页，
    if (isToLogin) {
      next();
    } else {
      next({ path: '/login' });
    }
    NProgress.done();

    // 退出时重置开关
    hasAddedRoutes = false;
  }
});

router.afterEach(() => {
  NProgress.done();
});
